
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.045 11.2h11.91c.577 0 1.045-.456 1.045-1.018V1.018C14 .456 13.532 0 12.955 0H1.045C.468 0 0 .456 0 1.018v9.164c0 .562.468 1.018 1.045 1.018zM.835 1.018c0-.112.095-.203.21-.203h11.91c.115 0 .21.091.21.203v7.309l-2.318-2.259a1.313 1.313 0 00-1.82 0l-.972.947-2.223-2.168a1.313 1.313 0 00-1.82 0L.836 7.944V1.018zm0 8.076l3.768-3.671a.46.46 0 01.638 0l2.814 2.745 1.561-1.523a.46.46 0 01.637 0l2.911 2.834v.703a.207.207 0 01-.209.204H1.045a.207.207 0 01-.21-.204V9.094z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.254 4.444c.691 0 1.253-.548 1.253-1.222C9.507 2.548 8.945 2 8.254 2 7.562 2 7 2.548 7 3.222c0 .674.562 1.222 1.254 1.222zm0-1.63c.23 0 .418.184.418.408a.414.414 0 01-.418.407.414.414 0 01-.418-.407c0-.224.188-.407.418-.407z","fill":"currentColor"}})])
          )
        }
      }
    